export default {
  ABOUT_US: {
    BEHIND_THE_SCENES_VIDEO: 'BEHIND_THE_SCENES_VIDEO',
    BACK_LABEL_VIDEO: 'BACK_LABEL_VIDEO',
  },
  BO_ADMIN: {
    SALES_LIMITATIONS: {
      CREATE_LIMITATION: 'CREATE_LIMITATION',
      DELETE_LIMITATION: 'DELETE_LIMITATION',
      EDIT_LIMITATION: 'EDIT_LIMITATION',
    },
    SALES: {
      UPDATE_PRODUCT: {
        PUT_ON_HOLD: 'PUT_ON_HOLD',
      },
    },
    RESTRICTED_CATEGORIES: {
      CREATE_RESTRICTED_CATEGORY: 'CREATE_RESTRICTED_CATEGORY',
      DELETE_RESTRICTED_CATEGORY: 'DELETE_RESTRICTED_CATEGORY',
      UPDATE_RESTRICTED_CATEGORY: 'UPDATE_RESTRICTED_CATEGORY',
    },
    CUSTOMERS: {
      ADDRESSES: 'ADDRESSES',
      ADD_CREDIT: 'ADD_CREDIT',
      CREDIT_REQUESTS: 'CREDIT_REQUESTS',
      DELETE_CUSTOMERS_DATA: 'DELETE_CUSTOMERS_DATA',
      GOODWILL_GESTURE: 'GOODWILL_GESTURE',
      ORDERS: 'ORDERS',
      BUYBACK_ORDERS: 'BUYBACK_ORDERS',
    },
    FINANCE: {
      CREDIT_REQUESTS: {
        CHANGE_STATUS: 'CHANGE_STATUS',
        IMPORT: 'IMPORT',
      },
      REASONS: {
        DETAIL: 'REASON_DETAIL',
      },
      SELLER_COMPENSATIONS: {
        CREATE_SELLER_COMPENSATION: 'CREATE_SELLER_COMPENSATION',
      },
    },
    PICSOU: {
      CREATE_BALANCE_ADJUSTMENT: 'CREATE_BALANCE_ADJUSTMENT',
      IMPORT_BALANCE_ADJUSTMENTS: 'IMPORT_BALANCE_ADJUSTMENTS',
    },
    CCBM_FEE_RULES: {
      IMPORT_CCBM_FEE_RULES: 'IMPORT_CCBM_FEE_RULES',
    },
  },
  CHECKOUT: {
    CART_COLLECTION_POINTS: 'CART_COLLECTION_POINTS',
    CART_INCLUDED_SERVICES: 'CART_INCLUDED_SERVICES',
    CART_INSURANCE_OFFER_CATCHUP: 'CART_INSURANCE_OFFER_CATCHUP',
    CART_INSURANCE_OFFER_EXPLANATIONS: 'CART_INSURANCE_OFFER_EXPLANATIONS',
    CART_SHIPPING: 'CART_SHIPPING',
    SUMMARY_SERVICE_FEE: 'SUMMARY_SERVICE_FEE',
  },
  BUYBACK: {
    // these are all the same modal but requires different id's
    // to avoid double openings (in the cart especcially)
    SWAP_PRODUCT: 'SWAP_PRODUCT',
    SWAP_ATC: 'SWAP_ATC',
    SWAP_CART: 'SWAP_CART',
    SWAP_CHECKOUT_SUMMARY: 'SWAP_CHECKOUT_SUMMARY',
    MY_SALES_SHIP_ITEM: 'MY_SALES_SHIP_ITEM',
    MY_SALES_PAYMENT_DETAILS: 'MY_SALES_PAYMENT_DETAILS',
    MY_SALES_COUNTER_OFFER: 'MY_SALES_COUNTER_OFFER',
    MY_SALES_CONFIRM_COUNTER_OFFER: 'MY_SALES_CONFIRM_COUNTER_OFFER',
    REFURBISHER_ORDER_SEND_PAYMENT: 'REFURBISHER_ORDER_SEND_PAYMENT',
    REFURBISHER_VIEW_COUNTER_OFFER: 'REFURBISHER_VIEW_COUNTER_OFFER',
    REFURBISHER_ORDER_ON_HOLD: 'REFURBISHER_ORDER_ON_HOLD',
  },
  KNOW_YOUR_CUSTOMER: {
    PROFILE_ADDRESS: 'PROFILE_ADDRESS',
    PROFILE_ADDRESS_EDIT: 'PROFILE_ADDRESS_EDIT',
    PROFILE_BANK_DETAILS_INFO_UPLOAD: 'PROFILE_BANK_DETAILS_INFO_UPLOAD',
    PROFILE_INFO_EDIT: 'PROFILE_INFO_EDIT',
    PROFILE_PASSWORD_EDIT: 'PROFILE_PASSWORD_EDIT',
    PROFILE_RIB_DELETE: 'PROFILE_RIB_DELETE',
  },
  MERCHANT: {
    ADDRESS_FORM: 'ADDRESS_FORM',
    ADDRESS_RULE: 'ADDRESS_RULE',
    DELETE_ADDRESS: 'DELETE_ADDRESS',
    DELETE_ADDRESS_RULE: 'DELETE_ADDRESS_RULE',
    DELETE_INTEGRATOR: 'DELETE_INTEGRATOR',
    DELETE_SHIPPING_METHOD: 'DELETE_SHIPPING_METHOD',
    INTERNATIONAL_ONBOARDING: 'INTERNATIONAL_ONBOARDING',
    OFFERS: {
      FILTERS: 'OFFERS_FILTERS',
      DRAWER: 'OFFERS_DRAWERS',
    },
    LISTINGS_ACTION_PANEL: 'LISTINGS_ACTION_PANEL',
    LISTINGS_LISTING_DETAIL: 'LISTINGS_LISTING_DETAIL',
    LISTINGS_MOBILE_FILTERS: 'LISTINGS_MOBILE_FILTERS',
    LISTINGS_MOBILE_SORT: 'LISTINGS_MOBILE_SORT',
    LISTINGS_NEW_GRADES: 'LISTINGS_NEW_GRADES',
    LISTINGS_PRICE_ALERT: 'LISTINGS_PRICE_ALERT',
    LISTINGS_SELECT_MARKET: 'LISTINGS_SELECT_MARKET',
    MAKE_AN_OFFER: 'MAKE_AN_OFFER',
    MARKET_LIST_SELECT_MARKET: 'MARKET_LIST_SELECT_MARKET',
    NEW_INTEGRATORS: 'NEW_INTEGRATORS',
    OPPORUNITY_PICTURE_MODAL: 'OPPORUNITY_PICTURE_MODAL',
    PAYPAL_SETTINGS: 'PAYPAL_SETTINGS',
    TERMS_AND_CONDITIONS: 'TERMS_AND_CONDITIONS',
    ONBOARDING: {
      WELCOME_SELLER: 'WELCOME_SELLER',
      EDIT_BUSINESS_DETAILS: 'EDIT_BUSINESS_DETAILS',
      EDIT_LEGAL_DETAILS: 'EDIT_LEGAL_DETAILS',
      EDIT_TAX_DETAILS: 'EDIT_TAX_DETAILS',
      EDIT_EPR_DETAILS: 'EDIT_EPR_DETAILS',
      DELETE_EPR_DETAILS: 'DELETE_EPR_DETAILS',
      EDIT_BANKING_DETAILS: 'EDIT_BANKING_DETAILS',
      INFORMATION_MODAL: 'INFORMATION_MODAL',
    },
    USER_PERMISSIONS: {
      ACTIVATE_OR_DEACTIVATE_USER: 'ACTIVATE_OR_DEACTIVATE_USER',
      USER_FORM: 'USER_FORM',
    },
    ORDERS: {
      BULK_ACTIONS_CONFIRMATION: 'BULK_ACTIONS_CONFIRMATION',
    },
  },
  MY_ORDERS: {
    ORDERS_ASK_BILL_MODAL: 'ORDERS_ASK_BILL_MODAL',
    ORDERS_BILLS_CHILLPACK_MODAL: 'ORDERS_BILLS_CHILLPACK_MODAL',
    ORDERS_BILLS_TRUSTPACK_MODAL: 'ORDERS_BILLS_TRUSTPACK_MODAL',
  },
  PAYMENT: {
    CREDIT_CARD_SECURITY_CODE: 'CREDIT_CARD_SECURITY_CODE',
  },
  REFER_FRIENDS: {
    HISTORY: 'REFER_FRIENDS_HISTORY',
    GENERATE_PROMO_CODE: 'REFER_FRIENDS_GENERATE_PROMO_CODE',
  },
  SAV_PLATFORM: {
    FALCON_RETURN_ONBOARDING: 'FALCON_RETURN_ONBOARDING',
    SOURCING_ORDERS_LIST_HELP: 'SOURCING_ORDERS_LIST_HELP',
    HELP_MODAL_NAME: 'HELP_MODAL_NAME',
    VISIBILITY_CONFIRMATION_MODAL: 'VISIBILITY_CONFIRMATION_MODAL',
    ONBOARDING_MODAL_3CR: 'ONBOARDING_MODAL_3CR',
  },
  VANISHING_DEALS: {
    PICKLE_PORTRAIT: 'PICKLE_PORTRAIT',
    GOOD_DEALS: 'GOOD_DEALS',
    BAD_DEALS: 'BAD_DEALS',
  },
  PRODUCT: {
    ADD_TO_CART: 'ADD_TO_CART',
    BUNDLE: 'BUNDLE',
    RENEWED_IMPACT: 'RENEWED_IMPACT',
    EXCLUDED_ACCESSORIES: 'EXCLUDED_ACCESSORIES',
    EXPRESS_SHIPPING: 'EXPRESS_SHIPPING',
    FAQ: 'FAQ',
    GRADES: 'GRADES_DETAILS',
    HIGHLIGHTED_PICKERS: 'HIGHLIGHTED_PICKERS',
    MEDIA_VIEWER: 'MEDIA_VIEWER',
    PERKS: 'PERKS',
    PREPAID_PLAN: 'PREPAID_PLAN',
    SERVICE_FEE: 'SERVICE_FEE',
    TECH_SPECS: 'TECH_SPECS',
  },
  REASSURANCE: {
    WARRANTY: 'WARRANTY',
    SATISFACTION: 'SATISFACTION',
  },
  REVIEWS: {
    REVIEWS_LEGAL_INFORMATION: 'REVIEWS_LEGAL_INFORMATION',
  },
}

export const MODAL_STATUS = {
  OPENED: 'opened',
  CLOSED: 'closed',
}
